import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=1ac62053&scoped=true&"
import script from "./userTable.vue?vue&type=script&lang=js&"
export * from "./userTable.vue?vue&type=script&lang=js&"
import style0 from "./userTable.vue?vue&type=style&index=0&id=1ac62053&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac62053",
  null
  
)

export default component.exports